
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import DownArrowSVG from '../assets/down-arrow.svg'

@Component({
  components: { DownArrowSVG }
})
export default class ScrollHintArrows extends Vue {
  @Prop({ required: true }) scrollWrapper!: HTMLElement

  private upArrowOpacity = 0
  private downArrowOpacity = 1

  mounted() {
    if (!this.scrollWrapper) return

    this.scrollWrapper.addEventListener('scroll', this.onScroll)
    this.updateArrowOpacities()
  }

  destroyed() {
    if (this.scrollWrapper) {
      this.scrollWrapper.removeEventListener('scroll', this.onScroll)
    }
  }

  @Watch('scrollWrapper')
  onScrollWrapperChanged(newWrapper: HTMLElement, oldWrapper: HTMLElement) {
    if (oldWrapper) {
      oldWrapper.removeEventListener('scroll', this.onScroll)
    }

    if (newWrapper) {
      newWrapper.addEventListener('scroll', this.onScroll)
      this.updateArrowOpacities()
    }
  }

  private onScroll = () => {
    this.updateArrowOpacities()
  }

  private updateArrowOpacities() {
    if (!this.scrollWrapper) return

    const scrollTop = this.scrollWrapper.scrollTop
    const scrollHeight = this.scrollWrapper.scrollHeight
    const clientHeight = this.scrollWrapper.clientHeight
    const scrollBottom = scrollHeight - scrollTop - clientHeight

    // Up arrow: fade in as you scroll down from top
    if (scrollTop < 64) {
      this.upArrowOpacity = 0
    } else {
      this.upArrowOpacity = 1
    }

    // Down arrow: fade out as you approach bottom
    if (scrollBottom < 64) {
      this.downArrowOpacity = 0
    } else {
      this.downArrowOpacity = 1
    }
  }

  private scrollUp() {
    if (!this.scrollWrapper) return
    this.scrollWrapper.scrollTo({ top: 0, behavior: 'smooth' })
  }

  private scrollDown() {
    if (!this.scrollWrapper) return
    this.scrollWrapper.scrollTo({ top: this.scrollWrapper.scrollHeight, behavior: 'smooth' })
  }
}
